//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios, { CancelToken } from "axios";

export default {
  data() {
    return {
      datalist: []
    };
  },
  async mounted() {
    let a = await this.LoadData();
  },
  methods: {
    LoadData() {
      const obj = axios({
        method: "post",
        url: `${this.$apiflask}nygctroom/setup/cutspeed/view` // php performance_nyg.py
      }).then(res => {
        // console.log(res.data);
        this.datalist = res.data.data;
      });
    },
    savedata(loc, val, val2) {
      const obj = axios({
        method: "post",
        url: `${this.$apiflask}/nygctroom/setup/cutspeed`, // php performance_nyg.py
        data: { loc: loc, speed: val, speed_sp: val2 }
      }).then(res => {
        // console.log(res.data);
        if (res.data.success == true) {
          this.$q.notify({
            position: "top-right",
            timeout: 1500,
            textColor: "white",
            color: "green",
            message: "Save Success",
            html: true
          });
        } else {
          this.$q.notify({
            position: "top-right",
            timeout: 1500,
            textColor: "white",
            color: "red",
            message: "Save Fail!",
            html: true
          });
        }
      });
    }
  }
};
